import ImgTop from 'assets/images/content/psychologische_beratung_seniorinnen.jpg'
import { Col, Container, Row, Section, ShareButtons } from 'atoms'
import Image from 'next/image'
import { ContactCard } from 'organisms'
import { FC } from 'react'

const AngeboteSeniorinnen: FC<unknown> = () => (
  <>
    <Section background="rose">
      <Container>
        <h1>
          Psyochologische Beratung und Begleitung für Seniorinnen
        </h1>
      </Container>
    </Section>
    <Section>
      <Container>
        <Row className="flex-md-row-reverse">
          <Col xs={12} md={8} xl={7} className="mb-4">
            <p>
              {`Für Seniorinnen, die gern in ihrer persönlichen Wohlfühlumgebung besucht werden möchten, biete ich meinen Exklusiven Seniorinnenservice:`}
            </p>
            <p>
              {`Ich besuche Sie in ihrem Zuhause und wir sprechen dort über die Themen, die Ihnen auf der Seele brennen.`}
            </p>
            <p>
              {`Oder wir vereinbaren eine Telefonzeit, zu der ich Sie anrufe und wir Zeit für das gemeinsame Gespräch haben.`}
            </p>
          </Col>
          <Col xs={12} md={4} xl={5} className="pull-left">
            <Image
              alt="Beratung und Begleitung für Seniorinnen"
              src={ImgTop}
              placeholder="blur"
            />
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            sm={10}
            offsetSm={1}
            md={8}
            offsetMd={2}
            lg={6}
            offsetLg={3}
            className="text-center mt-5"
          >
            <p>
              <strong>
                Ich bin einfühlsam, kompetent und zuverlässig an ihrer Seite.
              </strong>
            </p>
            <p>
              In mir haben Sie eine persönliche Bezugsperson, wenn der Schuh drückt.
            </p>
            <p>
              {`Haben Sie etwas entdeckt, was Sie anspricht? Wenn ja, kontaktieren Sie mich. Oder brennt Ihnen etwas anderes auf der Seele?`}
            </p>
            <p>
              {`Ich bin gern für Sie da, nehmen Sie Kontakt zu mir auf.`}
            </p>
          </Col>
        </Row>
      </Container>
    </Section>
    <Section background="vintage">
      <Container>
        <ContactCard />
      </Container>
    </Section>
    <Section>
      <Container>
        <ShareButtons className="d-none d-md-block" full />
        <ShareButtons className="d-block d-md-none" full size={40} />
      </Container>
    </Section>
  </>
)

export default AngeboteSeniorinnen
